import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, combineLatest} from 'rxjs';
import { map } from 'rxjs/operators';
import { Page } from 'src/app/core/models/Page';


@Injectable({
  providedIn: 'root'
})
export class GestionPmService implements Resolve<any> {
  routeParams: any;
  page: Page = new Page();

  constructor(
    private http: HttpClient
  ) {
    this.page.size = 20;
    this.page.pageNumber = 0;
    this.page.state = 0;
    this.page.filterView = 1;
  }


  resolve( router: ActivatedRouteSnapshot, state: RouterStateSnapshot ): Observable<any> | Promise<any> | any {
    this.routeParams = router.params;


    if (Object.keys(this.routeParams).length > 0) {
      return this.getUserData(this.routeParams);
    }
    return this.getUsers(this.page);
  }

  getProfile(): Observable<any> {
    return this.http.get<any>(`${environment.BACKEND}profile/list`);
  }

  getCondition(): Observable<any> {
    return this.http.get<any>(`${environment.BACKEND}ivaCondition/list`);
  }

  getjudgementTypes(): Observable<any> {
    return this.http.get<any>(`${environment.BACKEND}judgmentType/list`);
  }

  getColegiosAbogados(): Observable<any> {
    return this.http.get<any>(`${environment.BACKEND}colegios_abogados/list`);
  }

  getUsers(page): Observable<any> {
    const httpParams = new HttpParams({
      fromObject: page
    });
    return this.http.get<any>(`${environment.BACKEND}pm/user/list`, {
      params: httpParams
    });
  }

  getIndiUser(): Observable<any> {

    return this.http.get<any>(`${environment.BACKEND}pm/aptoNoApto/list`);
  }

  updateApto(body): Observable<any> {

    return this.http.put<any>(`${environment.BACKEND}pm/aptoNoApto/excepcionApto`, body);
  }

  uploadExcel(formData): Observable<any> {

    return this.http.post<any>(`${environment.BACKEND}pm/aptoNoApto/updateExcel`, formData);
  }

  getLiquidationByJurisdic(){
    return this.http.get<any>(`${environment.BACKEND}pm/aptoNoApto/liquidaciones`);
  }

  getHistoricoIndicadores(FECHA_HASTA){
    let objFecha ={
     };

     FECHA_HASTA !== null ? (objFecha ={
       FECHA_HASTA
      }) : null;
      const httpParams = new HttpParams({
        fromObject: objFecha
      });
    return this.http.get<any>(`${environment.BACKEND}pm/aptoNoApto/historico`,{
      params: httpParams
    });
  }

  getUser(id): Observable<any> {
    return this.http.get<any>(`${environment.BACKEND}pm/user/view/${id}`);
  }

  createUser(user): Observable<any> {
    return this.http.post<any>(`${environment.BACKEND}pm/user/create`, user);
  }

  updateUser(user): Observable<any> {
    return this.http.put<any>(`${environment.BACKEND}pm/user/edit/${user.id}`, user);
  }

  softDeleteUser(user): Observable<any> {
    return this.http.put<any>(`${environment.BACKEND}pm/user/change_status/${user.ID}`, user);
  }

  getBank(): Observable<any> {
    return this.http.get<any>(`${environment.BACKEND}bank/list`);
  }

  getAccountType(): Observable<any> {
    return this.http.get<any>(`${environment.BACKEND}accountType/list`);
  }

  createAccount(account): Observable<any> {
    return this.http.post<any>(`${environment.BACKEND}pm/account/create`, account);
  }

  getAccounts(id): Observable<any> {
    return this.http.get<any[]>(`${environment.BACKEND}pm/account/list/${id}`);
  }

  updateAccount(account): Observable<any> {
    return this.http.put<any>(`${environment.BACKEND}pm/account/update/${account.id}`, account);
  }

  setState(account, state): Observable<any> {
    return this.http.post<any>(`${environment.BACKEND}pm/account/setState`, { account, 'state': state});
  }

  getDisablements(): Observable<any> {
    return this.http.get<any>(`${environment.BACKEND}disablementType/list`);
  }

  getSanctionAndLicense(id): Observable<any> {
    return this.http.get<any>(`${environment.BACKEND}pm/sanctionAndLicense/list/${id}`);
  }

  createSanctionAndLicense(sanctionOrLicense): Observable<any> {
    return this.http.post<any>(`${environment.BACKEND}pm/sanctionAndLicense/create`, sanctionOrLicense);
  }

  updateSanctionAndLicense(sanctionOrLicense): Observable<any> {
    return this.http.put<any>(`${environment.BACKEND}pm/sanctionAndLicense/update`, sanctionOrLicense);
  }

  deleteSanctionAndLicense(sanctionOrLicense): Observable<any> {
    return this.http.put<any>(`${environment.BACKEND}pm/sanctionAndLicense/delete`, sanctionOrLicense);
  }

  getCourt(): Observable<any> {
    return this.http.get<any>(`${environment.BACKEND}court/list`);
  }

  getDistrict(): Observable<any> {
    return this.http.get<any>(`${environment.BACKEND}district/list`);
  }

  listDisOrCourt(id): Observable<any> {
    return this.http.get<any>(`${environment.BACKEND}pm/courtOrDistrict/list/?idUser=${id}`);
  }

  listTipoAcreenciaR(): Observable<any> {
    return this.http.get<any>(`${environment.BACKEND}pm/courtOrDistrict/tipoAcreencia`);
  }

  assignedDisOrCourt(disOrCourt): Observable<any> {
    return this.http.post<any>(`${environment.BACKEND}pm/courtOrDistrict/create`, disOrCourt);
  }

  updateDisOrCourt(disOrCourt): Observable<any> {
    return this.http.put<any>(`${environment.BACKEND}pm/courtOrDistrict/update`, disOrCourt);
  }

  consultarSituacion(value): Observable<any> {
    return this.http.post<any>(`${environment.BACKEND}pm/user/situacion_fiscal`,value);
  }

  getUserData(params) {
    return new Promise((resolve, reject) => {
      combineLatest(
        this.getUser(params.userId),
        this.getAccounts(params.userId),
        this.getSanctionAndLicense(params.userId),
        this.listDisOrCourt(params.userId)
      )
      .pipe(
        map(([userData, accountData, sancOrLicData, districtData]) => {
          return { userData, accountData, sancOrLicData, districtData };
        })
      )
      .subscribe(userData => {
        resolve(userData);
      });

    });
  }

  downloadXLS(page: { [key: string]: any }): Observable<Blob> {
    const httpParams = new HttpParams({ fromObject: page });

    return this.http.get(`${environment.BACKEND}pm/download-xls`, {
      params: httpParams,
      responseType: 'blob'
    });
  }

  downloadProcuXLS(page: { [key: string]: any }): Observable<Blob> {
    const httpParams = new HttpParams({ fromObject: page });

    return this.http.get(`${environment.BACKEND}pm/court/download-xls`, {
      params: httpParams,
      responseType: 'blob'
    });
  }

  downloadCSVAptitud(FECHA_HASTA): Observable<any> {
    let objFecha ={
    };

    FECHA_HASTA !== null ? (objFecha ={
      FECHA_HASTA
     }) : null;
     const httpParams = new HttpParams({
       fromObject: objFecha
     });
    return this.http.get(`${environment.BACKEND}pm/aptoNoApto/download`, {
      params: httpParams
    });
  }

}
